// src/pages/CampaignDashboard/CampaignHeader.js

import React, { useState, useRef, useEffect } from 'react';
import { IoArrowBack } from "react-icons/io5";

const CampaignHeader = ({
    campaignName,
    autopilotStatus,
    onBack,
    onRefreshPage,
    onViewSummary,
    onMailboxClick,
    onUpdateCampaign,
    onAddMatchingCompany,
    onAddContact,
    onPromptConfig,
    onSetupMeeting,
    onGenerateSelected,
    onGenerateWithPrompt,
    onSendEmailSelected,
    onSendLinkedinSelected,
    onDeleteSelected,
    onStartAutopilot,
    onStopAutopilot,
    onSetNumProspectToView,
    numProspecttoView
}) => {
    const [showConfigMenu, setShowConfigMenu] = useState(false);
    const [showActionMenu, setShowActionMenu] = useState(false);
    const [showProspectMenu, setShowProspectMenu] = useState(false);

    const configMenuRef = useRef(null);
    const actionMenuRef = useRef(null);
    const prospectMenuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (configMenuRef.current && !configMenuRef.current.contains(event.target)) setShowConfigMenu(false);
            if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) setShowActionMenu(false);
            if (prospectMenuRef.current && !prospectMenuRef.current.contains(event.target)) setShowProspectMenu(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="flex justify-between items-center p-6 bg-gray-50">
            <div className="flex items-center gap-4">
                <button onClick={onBack} className="p-2 text-black bg-gray-200 rounded-full hover:bg-gray-300">
                    <IoArrowBack size={20} />
                </button>
                <h2 className="text-2xl font-bold text-black">{`${campaignName}: Prospect List`}</h2>
            </div>
            <div className="flex flex-wrap items-center gap-4">
                <button onClick={onRefreshPage} className="px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-300 hover:bg-gray-100">Refresh Page</button>
                <button onClick={onViewSummary} className="px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-300 hover:bg-gray-100">Campaign Summary</button>
                <button onClick={onMailboxClick} className="px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-300 hover:bg-gray-100">Unibox</button>

                {/* Config Dropdown */}
                <div className="relative" ref={configMenuRef}>
                    <button onClick={() => setShowConfigMenu(!showConfigMenu)} className="px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-300 hover:bg-gray-100">
                        Config <span className="ml-1">▼</span>
                    </button>
                    {showConfigMenu && (
                        <div className="absolute top-full right-0 bg-white border rounded-md shadow-lg z-50 mt-1">
                            {/* ... menu items calling props like onUpdateCampaign */}
                        </div>
                    )}
                </div>

                {/* Action Dropdown */}
                <div className="relative" ref={actionMenuRef}>
                    <button onClick={() => setShowActionMenu(!showActionMenu)} className="px-4 py-2 bg-white text-gray-700 rounded-full border border-gray-300 hover:bg-gray-100">
                        Action <span className="ml-1">▼</span>
                    </button>
                    {showActionMenu && (
                         <div className="absolute top-full right-0 bg-white border rounded-md shadow-lg z-50 mt-1">
                            {/* ... menu items calling props like onGenerateSelected */}
                         </div>
                    )}
                </div>

                {/* Autopilot Button */}
                {!autopilotStatus ? (
                    <button onClick={onStartAutopilot} className="px-4 py-2 rounded-full bg-green-600 hover:bg-green-700 text-white">Start AutoPilot</button>
                ) : (
                    <button onClick={onStopAutopilot} className="px-4 py-2 rounded-full bg-red-600 hover:bg-red-700 text-white">Stop AutoPilot</button>
                )}

                {/* View Dropdown */}
                <div className="relative" ref={prospectMenuRef}>
                    {/* ... View dropdown logic ... */}
                </div>
            </div>
        </div>
    );
};

export default CampaignHeader;